import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-environment-list',
  templateUrl: './environment-list.page.html',
  styleUrls: ['./environment-list.page.scss'],
})
export class EnvironmentListPage implements OnInit {
  selectAfterAdding = true;
  envForm: FormGroup;

  constructor(
    private _fb: FormBuilder,
    public modalCtrl: ModalController,
    private dialogRef: MatDialogRef<EnvironmentListPage>,
    @Inject(MAT_DIALOG_DATA) public data: EnvironmentListPage,
  ) { }

  ngOnInit(): void {
    this.envForm = this._fb.group({
      environment_name: ['', Validators.required], // Add Validators.required to make it a required field
    });   
  }

  closeModal() {
    this.dialogRef.close();
  }

  onFormSubmit() {
    if (this.envForm.valid) {
      let data = {
        environment_name: this.envForm.get('environment_name').value,
      };
      this.dialogRef.close({ data: data, event: 'close' });
    }
  }
}